import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREAUCT_Investor_Pledge.css';

const PREAUCT_Investor_Pledge = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREAUCT_INVESTOR_PLEDGE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREAUCT_INVESTOR_PLEDGE:-1
  });


  const [PREAUCT_INVESTOR_PLEDGE, setPREAUCT_INVESTOR_PLEDGE] = React.useState(null);
  const [PREAUCT_INVESTOR_PLEDGE_D, setPREAUCT_INVESTOR_PLEDGE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Investor Pledge');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREAUCT_INVESTOR_PLEDGE(clientInfo,"OpenNew");

		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREAUCT_INVESTOR_PLEDGE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREAUCT_INVESTOR_PLEDGE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREAUCT_INVESTOR_PLEDGE(clientInfo,"OpenNew");
		}
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
		if(Temp_Data2.status!="New"){
			handleDeletePREAUCT_INVESTOR_PLEDGE(Temp_Data2);
			navigate('/PREAUCT_Investor_Pledge#New',{replace:true});
		} 
		else 
			navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Investor_Pledge',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREAUCT_INVESTOR_PLEDGE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREAUCT_INVESTOR_PLEDGE]) ;


  
  
  var Ids = [];
  for(var Ele in PREAUCT_INVESTOR_PLEDGE){
	  for(var Sec in PREAUCT_INVESTOR_PLEDGE[Ele]){
		if(Sec == "id")
			Ids.push(PREAUCT_INVESTOR_PLEDGE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREAUCT_INVESTOR_PLEDGE[Ele]["status"]);
		else if(Array.isArray(PREAUCT_INVESTOR_PLEDGE[Ele][Sec]))
			  for(var Row in PREAUCT_INVESTOR_PLEDGE[Ele][Sec])  // Convert to PREAUCT_INVESTOR_PLEDGE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREAUCT_INVESTOR_PLEDGE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREAUCT_INVESTOR_PLEDGE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREAUCT_INVESTOR_PLEDGE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE`).then((response1) => {
		if(!PREAUCT_INVESTOR_PLEDGE) 
			setPREAUCT_INVESTOR_PLEDGE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE_D`).then((response2) => {
			setPREAUCT_INVESTOR_PLEDGE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREAUCT_INVESTOR_PLEDGE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREAUCT_INVESTOR_PLEDGE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREAUCT_INVESTOR_PLEDGE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREAUCT_INVESTOR_PLEDGE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREAUCT_INVESTOR_PLEDGE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREAUCT_INVESTOR_PLEDGE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREAUCT_INVESTOR_PLEDGE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_INVESTOR_PLEDGE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["1"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  


const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  


const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["2"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  

  
      
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["3"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  


  
      
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["3"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  


  
      
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["3"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  



const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["4"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  


const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
  }; 
  

    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
	Temp_Data["9"]["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"]=value;
	//handleAddPREAUCT_INVESTOR_PLEDGE(Temp_Data,App_Data['PREAUCT_INVESTOR_PLEDGE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_INVESTOR_PLEDGE(Temp_Data);
    setPREAUCT_INVESTOR_PLEDGE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREAUCT_INVESTOR_PLEDGE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREAUCT_INVESTOR_PLEDGE =JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
  updatedPREAUCT_INVESTOR_PLEDGE[Sec] = [...updatedPREAUCT_INVESTOR_PLEDGE[Sec], newRow];
  setPREAUCT_INVESTOR_PLEDGE(updatedPREAUCT_INVESTOR_PLEDGE);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREAUCT_INVESTOR_PLEDGE = JSON.parse(JSON.stringify(PREAUCT_INVESTOR_PLEDGE));
  updatedPREAUCT_INVESTOR_PLEDGE[sec].splice(index, 1);
  setPREAUCT_INVESTOR_PLEDGE(updatedPREAUCT_INVESTOR_PLEDGE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Pre-Auction Investor Pledge`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pre-Auction Pledge ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pledge ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0" type="text" className="form-control" placeholder="PREAUCT Pledge ID" value={PREAUCT_INVESTOR_PLEDGE["1"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pledge ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pre Auction Pool ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1" type="text" className="form-control" placeholder="PREAUCT Pre Auction Pool ID" value={PREAUCT_INVESTOR_PLEDGE["1"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pre Auction Pool ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2" type="text" className="form-control" placeholder="Investor ID" value={PREAUCT_INVESTOR_PLEDGE["1"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Pledge Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3" type="text" className="form-control" placeholder="Pledge Amount USD" value={PREAUCT_INVESTOR_PLEDGE["1"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Pledge Amount USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Escrow Deposit ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Deposit ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0" type="text" className="form-control" placeholder="Escrow Deposit ID" value={PREAUCT_INVESTOR_PLEDGE["2"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Deposit ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1"  value={PREAUCT_INVESTOR_PLEDGE["2"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1`]} onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_1_Change} className="form-control" name="Payment Method"  >
						  <option value="ACH">ACH</option>
						  <option value="Wire">Wire</option>
						  <option value="Card">Card</option>
						  <option value="Check">Check</option>
						  <option value="Internal Transfer">Internal Transfer</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Method
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2"  value={PREAUCT_INVESTOR_PLEDGE["2"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2`]} onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_2_Change} className="form-control" name="Payment Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Received">Received</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Failed">Failed</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Paid">Paid</option>
						  <option value="Partially Paid">Partially Paid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Refund Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3"  value={PREAUCT_INVESTOR_PLEDGE["2"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3`]} onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_2_3_Change} className="form-control" name="Refund Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Completed">Completed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Refund Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Risk Acknowledged`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Risk Acknowledged`)} <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0_Change} 
					  checked={PREAUCT_INVESTOR_PLEDGE?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"] === "true" || PREAUCT_INVESTOR_PLEDGE?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Conditional Nature Acknowledged`)} <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1_Change} 
					  checked={PREAUCT_INVESTOR_PLEDGE?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"] === "true" || PREAUCT_INVESTOR_PLEDGE?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`No Token Until Winning Bid Acknowledged`)} <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2_Change} 
					  checked={PREAUCT_INVESTOR_PLEDGE?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"] === "true" || PREAUCT_INVESTOR_PLEDGE?.["3"]?.["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_3_2"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pledge Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Pledge Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0"  value={PREAUCT_INVESTOR_PLEDGE["4"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0`]} onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_4_0_Change} className="form-control" name="Pledge Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Funded">Funded</option>
						  <option value="Accepted">Accepted</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Pledge Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0"  value={PREAUCT_INVESTOR_PLEDGE["9"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0`]} onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1" type="text" className="form-control" placeholder="Created By" value={PREAUCT_INVESTOR_PLEDGE["9"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2" type="text" className="form-control" placeholder="Created At" value={PREAUCT_INVESTOR_PLEDGE["9"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3" type="text" className="form-control" placeholder="Updated By" value={PREAUCT_INVESTOR_PLEDGE["9"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4" type="text" className="form-control" placeholder="Updated At" value={PREAUCT_INVESTOR_PLEDGE["9"][`PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4`]} 
						onChange={PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_04_INVESTOR_PLEDGE_ESCROW_FUNDING_PREAUCT_INVESTOR_PLEDGE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREAUCT_Investor_Pledge;  